<template>
  <Container type="card-full">
    <div slot="header">
      <menu-btn :menuid="menuid" @btnClick="btnClick"></menu-btn>
    </div>
    <vgtree ref="xTree" :list="list" tableheight="700" flexname="" :cols="cols" :showfooter="false"
            :showPage="false" :resizable="true" :total="query.total"
            @cellClick="cellClick" @pagechange="pagechange" @getxTree="getxTree">
    </vgtree>
    <el-dialog :title="addOrInsertFlg === 1 ? '新增' : '插入下级分类'" :visible.sync="letform">
      <el-form class="small-space" :model="letrec" label-position="left" label-width="120px" style='width: 400px; margin-left:50px;'>
        <el-form-item label="编号" required>
          <el-input v-model="letrec.letcode"></el-input>
        </el-form-item>
        <el-form-item label="名称" required>
          <el-input v-model="letrec.letname" ></el-input>
        </el-form-item>
        <el-form-item label="上级分类" v-if="addOrInsertFlg===2">
          <el-input v-model="letrec.letparentname" disabled></el-input>
        </el-form-item>
        <el-form-item label="层级" required>
          <el-input v-model="letrec.letlaycount" disabled></el-input>
        </el-form-item>
        <el-form-item label="本层顺序号" required>
          <el-input v-model="letrec.letseq" disabled></el-input>
        </el-form-item>
        <el-form-item label="是最末级分类" required>
          <el-checkbox v-model="letrec.letisend"></el-checkbox>
        </el-form-item>
        <el-form-item label="备注">
          <el-input v-model="letrec.letremark" ></el-input>
        </el-form-item>
      </el-form>

      <div slot="footer">
        <el-button type="primary" @click="save">保存</el-button>
        <el-button @click="letform = false">关闭</el-button>
      </div>
    </el-dialog>
  </Container>
</template>
<script>
  import request from  '@/utils/request'
  import MenuBtn from "../common/menuBtn"
  import vgtree from '../common/vgtree1'
  import utils from '../../assets/js/utils'
  export default {
    name: 'letIndex',
    data () {
      return {
        menuid: this.$route.query.menuid,
        list: [],
        cols: [
          { type: 'index',fieldtype: 'I', title: '行号',calculExpr:'', width: 80},
          { field: 'letcode', fieldtype: 'C', title: '编号',calculExpr:'', addNewRowFlg: false,editRender: { name: 'input'}},
          { field: 'letname', fieldtype: 'C', title: '名称',calculExpr:'',addNewRowFlg: false,editRender: { name: 'input'}},
          { field: 'letlaycount', fieldtype: 'I', title: '层级',calculExpr:'',addNewRowFlg: false,editRender: { name: 'input'}},
          { field: 'letseq', fieldtype: 'I',title: '本层顺序号',calculExpr:'',addNewRowFlg: false,editRender: { name: 'input'}},
          { field: 'letisend', fieldtype: 'B',title: '是末级', syscode: 'letisend', calculExpr:'',addNewRowFlg: false,editRender: { name: 'select', options: []}},
          { field: 'letremark', fieldtype: 'C',title: '备注',calculExpr:'',addNewRowFlg: false,editRender: { name: 'input'}}
        ],
        letform: false,
        xTree: {},
        letrec: {},
        addOrInsertFlg: 1,
        query: {
          comid: this.$store.getters.loginUser.usercomid,
          total: 0,
          currPage: 1,
          pageSize: 20
        }
      }
    },
    created () {
      this.$on('ADD', () => this.addLet())
      this.$on('INS', () => this.insertLet())
      this.$on('SAV', () => this.saveLet())
      this.$on('DEL', () => this.delLet())
      this.$on('OPEN', () => this.openLet())
      this.$on('PACKUP', () => this.packupLet())
      this.$on('CLOSE', () => this.close())
    },
  activated() {
    this.init()
    this.getLetList()
  },
  mounted () {
    },
    components: {MenuBtn,vgtree},
    methods: {
      async init() {
        this.menuid = this.$route.query.menuid
        this.list = []
        this.letform = false
        this.xTree = {}
        this.letrec = {}
        this.addOrInsertFlg = 1
      },
      btnClick (code) {
        this.$emit(code)
      },
      async close() {
        this.$store.commit('close_tab', {routeName: this.$route.name, vm: this, newRouteName: ''})
      },
      async addLet () {
        let maxseq = 0
        this.list.forEach(item => {
            if (item.letlaycount === 1 && item.letseq>maxseq) {
              maxseq = item.letseq
            }
        })
        this.addOrInsertFlg = 1
        this.letrec = {
          comid: this.$store.getters.loginUser.usercomid,
          letcode: '',
          letname: '',
          letparentid: 0,
          letparentname: '',
          letlaycount: 1,
          letisend: 0,
          letremark:'',
          letseq: Number(maxseq) + 1
        }
        this.letform = true
      },
      async insertLet () {
        if (!this.letrec.letid) {
          this.$message.warning('请选择需要插入下级分类的行!')
          return
        }
        let maxseq = 0
        this.letrec.children.forEach(item => {
          if (item.letlaycount === 1 && item.letseq>maxseq) {
            maxseq = item.letseq
          }
        })
        this.addOrInsertFlg = 2
        this.letrec = {
          comid: this.$store.getters.loginUser.usercomid,
          letcode: '',
          letname: '',
          letparentid: this.letrec.letid,
          letparentname: this.letrec.letname+'('+this.letrec.letcode+')',
          letlaycount: this.letrec.letlaycount+1,
          letisend: 0,
          letremark:'',
          letseq: Number(maxseq) + 1
        }
        this.letform = true
      },
      async packupLet () {
        this.$refs.xTree.$refs.xTree.clearTreeExpand()
      },
      async openLet () {
        this.$refs.xTree.$refs.xTree.setAllTreeExpansion(true)
      },
      async delLet () {
        if (!this.letrec.letid) {
          this.$message.warning('请选择一条数据!')
          return
        }
        this.$confirm('确定删除?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(async () => {
          let data = await request({
            url: '/basic/let/dellet',
            method: "post",
            data: this.letrec
          })
          if (data.issuccess===1) {
            this.getLetList()
            this.$message.success('删除成功！')
          } else {
            this.$message.error(data.msg)
          }
        })
      },
      handleSizeChange (val) {
        this.query.pageSize = val
        this.getLetList()
      },
      handleCurrentChange (val) {
        this.offset = val
        this.getLetList()
      },
      search (target) {},
      async save () {
        let model = {
          insertRecords: [this.letrec],
          updateRecords: [],
          removeRecords: []
        }
        await this.addOrEdit(model)
        this.letform = false
      },
      async saveLet () {
        let model = this.$refs.xTree.$refs.xTree.getRecordset()
        this.addOrEdit(model)
      },
      async addOrEdit (model) {
        if (model.insertRecords.length===0 && model.updateRecords.length === 0 && model.removeRecords.length ===0) {
          this.$message.warning('数据没有修改，不需要保存')
          return
        }
        let data = await request({
          url: '/basic/let/addOrEdit',
          method: "post",
          data: model
        })
        if (data.issuccess===1) {
          this.getLetList()
          this.$message.success('保存成功')
        } else {
          this.$message.error('保存失败')
        }
      },
      async getxTree(xtree) {
        this.xTree = xtree
      },
      async cellClick (row) {
        this.letrec = row.row
      },
      async pagechange (letPage) {
        this.query.currPage = letPage.currentPage
        this.query.pageSize = letPage.pageSize
        this.getLetList()
      },
      async getLetList () {
        this.loading = true
        let res = await request({
          method: 'get',
          url: '/basic/let/getLetTree',
          params: this.query
        })
        this.list = res.list
        this.query.total = res.count
        this.loading = false
      }
    },
    filters: {
      num (val) {
        return Number(val)
      }
    }
  }
</script>
<style lang="scss">

</style>
